import { cx } from "@emotion/css";
import type * as React from "react";
import * as styles from "./LegacyDataTableStyles";
type LegacyDataTableFooterColumnProps = React.DetailedHTMLProps<React.TdHTMLAttributes<HTMLTableDataCellElement>, HTMLTableDataCellElement>;
export function LegacyDataTableFooterColumn({ className, children, ...otherProps }: LegacyDataTableFooterColumnProps): React.ReactElement {
    return (<td className={cx(styles.dataTableFooterColumn, className)} {...otherProps}>
            {children}
        </td>);
}
